import React, { memo, useCallback, useMemo, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";

import AppIcon from "components/app-icon";
import classNames from "common/class-names";

const AppButton = (props) => {
	const counter = useRef();
	const [loading, setLoading] = useState("");
	const [animation, setAnimation] = useState(false);

	const className = useMemo(() => {
		return classNames({
			"app-button": true,
			"app-button--outline": props.outline || false,
			...(props.className && {
				[props.className]: true,
			}),
			"app-button-loading--active": animation
		});
	}, [props.className, props.outline, animation]);

	const Icon = useCallback(() => {
		if (typeof props.icon === "string") {
			return <AppIcon src={props.icon} />;
		} else if (props.icon) {
			return props.icon;
		} else {
			return null;
		}
	}, [props.icon, props.disabled]);

	useEffect(() => {
		if (props.showLoadingDots) {
			setAnimation(true);
			counter.current = setInterval(() => {
				setLoading((prev) => (prev.length >= 3 ? "" : prev + "."));
			}, 500);
		} else {
			setAnimation(false);
			clearInterval(counter.current);
			setLoading("");
		}
		return () => clearInterval(counter.current);
	}, [props.showLoadingDots]);

	return (
		<button className={className} type={props.type} disabled={props.disabled} onClick={props.onClick}>
			{props.showLoadingDots && <p className="app-button-loading__dot">{loading}</p>}
			<Icon />
			<p className="app-button__label">{props.label}</p>
		</button>
	);
};

AppButton.propTypes = {
	onClick: PropTypes.func,
	outline: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["button", "submit", "reset"]).isRequired,
	showLoadingDots: PropTypes.bool,
};

export default memo(AppButton);
